export function SaunaLogo({ size = 42 }: { size?: number }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-label="SaunaCreator"
        >
            {/* Minimalist foundation line */}
            <path d="M3 20h18" strokeWidth="2" />
            {/* Elegant cabin volume */}
            <path d="M6 20v-8a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v8" />
            {/* Sophisticated steam integration */}
            <path d="M12 6c0-2 2-3 2-4.5S13 0 12 0 10 1.5 10 3s2 2.5 2 4.5z" strokeWidth="1" fill="currentColor" fillOpacity="0.15" />
        </svg>
    );
}
